import { useContext, useEffect, useState } from "react";
import client from "../../../contentfulClient";
import "./AnalysisServices.scss";
import { MainContext } from "../../../MainContext";
import useScrollAnimation from "../../useAnimationScrolling";

export const AnalysisServices = () => {
    const {
        analysisServices,
		staticTexts: { voice: staticTexts },
		staticTexts: { learnMoreButton: learnMoreButton },
        analysisServicesRef,
        openModal,
    } = useContext(MainContext);

    const animationConfig = {
        scale: [0, 1],
        opacity: [0, 1],
        duration: 1000,
        easing: "easeOutExpo",
    };

    useScrollAnimation(analysisServicesRef, animationConfig, analysisServices);

    return (
        <div
            className="analysis-container"
            ref={(el) => {
                if (el) analysisServicesRef.current[analysisServices + 1] = el;
            }}
        >
            <div className="main-image" style={{ backgroundImage: `url(${staticTexts.image})` }}></div>
            <section className="analysis-services">
                <h2 className="text">{staticTexts.title}</h2>

                <p className="description">{staticTexts.subTitle}</p>

                <div className="grid">
                    {analysisServices.map((service: any, index: number) => (
                        <div
                            className="analysis-card"
                            ref={(el) => {
                                if (el) analysisServicesRef.current[index] = el;
                            }}
                            key={index}
                        >
                            <img src={service.image} alt="" className="image" />
                            <h3 className="title">{service.title}</h3>
                            <p className="analysis-description">{service.subTitle}</p>
                            <div className="btn-gray" onClick={() => openModal({ ...service })}>
                                {learnMoreButton.text}
                            </div>
                        </div>
                    ))}
                </div>
            </section>
        </div>
    );
};
